/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import FlattenToolIcon from 'icons/FlattenToolIcon';

const messages = defineMessages({
  title: {id: 'navigation.data-tools.flatten'},
});

const FlattenItem = () => (
  <RouteLinkItem
    iconBefore={FlattenToolIcon}
    route="midas/data-tools/flatten-tool"
    title={messages.title}
  />
);

export default FlattenItem;
